import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import "./MainLayout.scss";
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import Menu from "@/components/Menu/Menu.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      inversed: "",
      back: ""
    }),
    _createVNode(_component_RouterView),
    _createVNode(Footer),
    _createVNode(Menu)
  ], 64))
}
}

})